module.exports = __webpack_public_path__ + "static/03-778416b628fb611b36f21182e4cf988a.jpg";